import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  showMoreloadingSpinnerContainer: {
    width: "fit-content",
    height: "fit-content",
  },
  contactShowMoreSpinnerSection: {
    position: "relative",
    width: "86.49px",
    height: "104px",
    margin: "12px auto",
  },
  gridContainer: {
    display: "flex",
    flex: "1 1 100%",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  progressWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "& div": {
      width: "100px",
      display: "flex",
    },

    "& label": {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  row: {
    height: 100,
  },
  badgeSection: {
    display: "flex",
    gap: "6px",
  },
  socialLinks: {
    height: "28px",
  },
  dateText: {
    display: "flex",
    flexDirection: "column",

    "& label": {
      lineHeight: "20px",
      fontWeight: 500,
    },

    "& span": {
      lineHeight: "20px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
    },
  },
  flexCol: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",

    "& span": {
      lineHeight: "24px",
      fontSize: "16px",
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
  },
  //
  defaultAvatar: {
    background: theme.palette.background.secondary_hover,
    border: `1px solid ${theme.palette.border.avatarContrast}`,
    height: "40px",
    width: "40px",

    "& img": {
      height: "24px",
      width: "24px",
    },
  },
  avatar: {
    background: theme.palette.background.secondary_hover,
    border: `1px solid ${theme.palette.border.avatarContrast}`,
    height: "40px",
    width: "40px",

    "& img": {
      objectFit: "contain",
    },
  },
  selectContainer: {
    display: "flex",

    "& .select-wrapper.MuiFormControl-root.theme-default": {
      maxWidth: "325px",
    },
  },
  container: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  detailsColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  nameRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
  },
  socialLinksBox: {
    height: "28px",
  },
  nameText: (props) => ({
    lineHeight: "24px",
    fontSize: "16px",
    fontWeight: 500,
    color: props?.isDarkMode ? "#F5F5F6" : "#101828",
  }),
}));
